import React, { createContext, useState, useContext, useEffect } from 'react';

const ConsentContext = createContext(null);

export const ConsentProvider = ({ children }) => {
  const [consentStatus, setConsentStatus] = useState(() => {
    return localStorage.getItem('cookieConsent') || 'pending';
  });

  const updateConsent = (status) => {
    setConsentStatus(status);
    localStorage.setItem('cookieConsent', status);
  };

  return (
    <ConsentContext.Provider value={{ consentStatus, updateConsent }}>
      {children}
    </ConsentContext.Provider>
  );
};

export const useConsent = () => {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error('useConsent must be used within a ConsentProvider');
  }
  return context;
};